import { Component, ViewEncapsulation, ElementRef, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { ModalService } from './../../services/modal.service';

@Component({ 
    selector: 'aw-modal', 
    templateUrl: 'modal.component.html', 
    styleUrls: ['modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() id: string;
    private element: any;

    @ViewChild('modal') modal: ElementRef;
    @ViewChild('modalBackground') modalBackground: ElementRef;

    constructor(private modalService: ModalService, private el: ElementRef) {
        this.element = el.nativeElement;
    }

    ngOnInit(): void {
        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', el => {
            if (el.target.className === 'aw-modal') {
                this.close();
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when component is destroyed
    ngOnDestroy(): void {
        this.modalService.remove(this.id);
        this.element.remove();
    }

    // open modal
    open(): void {
        
        // We support up to 3 modal windows open at one time. The
        // following two "if" statements will help control the CSS
        // z-index of all the open modals / background overlays.
        if (this.modalService.openModalCount === 2)
        {
            this.modal.nativeElement.classList.add('second');
            this.modalBackground.nativeElement.classList.add('second-background');
        }

        if (this.modalService.openModalCount === 3)
        {
            this.modal.nativeElement.classList.add('third');
            this.modalBackground.nativeElement.classList.add('third-background');
        }

        this.element.style.display = 'block';
        document.body.classList.add('aw-modal-open');
    }

    // close modal
    close(): void {
        this.element.style.display = 'none';
        document.body.classList.remove('aw-modal-open');
    }
}